import { render, staticRenderFns } from "./DetailsContent.vue?vue&type=template&id=0e1e568f&scoped=true&"
import script from "./DetailsContent.vue?vue&type=script&lang=js&"
export * from "./DetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsContent.vue?vue&type=style&index=0&id=0e1e568f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1e568f",
  null
  
)

export default component.exports